/**
 * Returns all elements that might be focusable, in depth-first order
 * in the DOM, under and including the `container` parameter
 *
 * @param container - the element under which to begin searching, inclusive
 * @returns an array of elements that can receive focus
 */
export function findFocusables(container) {
  // List of elements that are considered "focusable" by a keyboard
  const focusableElementsSelector = 'button,input,select,textarea,a[href],[tabindex]';
  const focusableElements = Array.from(container.querySelectorAll(focusableElementsSelector)); // Remove these elements from the focusable list

  const unfocusableElementsSelector = '[tabindex="-1"]'; // Remove elements from the focusable list that match or are descendants of
  // these elements

  const unfocusableAncestorsSelector = '[disabled],[aria-disabled="true"]';
  const unfocusableAncestors = Array.from(container.querySelectorAll(unfocusableAncestorsSelector));
  return focusableElements.filter(focusable => !focusable.matches(unfocusableElementsSelector)).filter(focusable => !unfocusableAncestors.some(unfocusableAncestor => unfocusableAncestor.contains(focusable)));
}
//# sourceMappingURL=find-focusables.js.map